import { activeSiteConfig, reCaptchaIntegrationEnabled } from "@config/site/site-config";
import { ABTestingScript } from "@lib/analytics/ABTesting";
import { CookieConsentScript } from "@lib/analytics/CookieConsentScript";
import { GtmScript } from "@lib/analytics/GtmScript";
import { Recaptcha } from "@lib/analytics/RecaptchaScript";
import { RumScript } from "@lib/analytics/RumScript";
import dynamic from "next/dynamic";

const TrueFitScript = dynamic(() => import("@lib/analytics/true-fit/TrueFitScript"), {
    ssr: false,
});
const KlarnaSiteMessaging = dynamic(() => import("@lib/analytics/KlarnaSiteMessaging"), {
    ssr: false,
});
const InsiderTag = dynamic(() => import("@lib/analytics/InsiderTag"), {
    ssr: false,
});
const RaffleFAQ = dynamic(() => import("@lib/raffle/RaffleFAQ"), {
    ssr: false,
});
const BazaarvoiceScript = dynamic(() => import("@lib/analytics/BazaarvoiceScript"), {
    ssr: false,
});
const GrabPayWidgetScript = dynamic(() => import("../analytics/GrabPayWidgetScript"), {
    ssr: false,
});
const AttentiveScript = dynamic(() => import("@lib/marketing-sms-email/Attentive"), {
    ssr: false,
});

const GlobalScripts = ({ locale }) => {
    const { externalScripts } = activeSiteConfig ?? {};

    const CookieConsentEnabled = process.env.NEXT_PUBLIC_COOKIE_CONSENT_ENABLED === "true";
    const RumAnalyticsEnabled = process.env.NEXT_PUBLIC_RUM_ANALYTICS_ENABLED === "true";
    const GtmEnabled = process.env.NEXT_PUBLIC_GTM_ENABLED === "true";
    const InsiderTagEnabled = process.env.NEXT_PUBLIC_INSIDER_TAG_ENABLED === "true";
    const bazaarvoiceEnabled = process.env.NEXT_PUBLIC_BAZAARVOICE_ENABLED === "true";
    const ABTestingEnabled = process.env.NEXT_PUBLIC_AB_TESTING_ENABLED === "true";
    const AttentiveEnabled = externalScripts?.attentive ?? false;

    return (
        <>
            {CookieConsentEnabled && <CookieConsentScript locale={locale} />}
            {RumAnalyticsEnabled && <RumScript />}
            {GtmEnabled && <GtmScript />}
            {reCaptchaIntegrationEnabled && <Recaptcha />}
            {activeSiteConfig?.hasTrueFit && <TrueFitScript />}
            {activeSiteConfig?.onKlarnaSiteMessaging && <KlarnaSiteMessaging />}
            {InsiderTagEnabled && <InsiderTag />}
            {ABTestingEnabled && <ABTestingScript />}
            {activeSiteConfig?.hasRaffle && <RaffleFAQ />}
            {bazaarvoiceEnabled && <BazaarvoiceScript />}
            {activeSiteConfig?.hasGrabPayWidget && <GrabPayWidgetScript />}
            {AttentiveEnabled && <AttentiveScript />}
        </>
    );
};

export default GlobalScripts;
